import axios from '../api'
/**
 * 查询组发票申请列表
 *
 */
const getInvoiceApplyRecords = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/invoice/getInvoiceApplyRecords`,
    params
  })
}
/**
 * 查询组可开票金额
 *
 */
const getGroupCanInvoiceInfo = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/invoice/getGroupCanInvoiceInfo`,
    params
  })
}
/**
 * 查询组所在公司的发票抬头列表
 *
 */
const getInvoiceTitleList = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/invoice/getInvoiceTitleList`,
    params
  })
}
/**
 * 查询组最近开票的邮箱
 *
 */
const getGroupRecentEmail = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/invoice/getGroupRecentEmail`,
    params
  })
}
/**
 * 出行券开票
 *
 */
const applyInvoice = params => {
  return axios({
    url: `/eos/coupon/invoice/applyInvoice`,
    method: 'post',
    data: params,
    headers: {'content-type': 'application/x-www-form-urlencoded'},
    isFormData: true
  })
}
export default {
  getInvoiceApplyRecords,
  getGroupCanInvoiceInfo,
  getInvoiceTitleList,
  getGroupRecentEmail,
  applyInvoice
}
